const DOCUMENT = 'TALENT_REFERRALS_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  TOGGLE_MODAL: DOCUMENT + 'TOGGLE_MODAL',
  CHANGE_SEARCH: DOCUMENT + 'CHANGE_SEARCH',
  CHANGE_FILTERED_PARAMS: DOCUMENT + 'CHANGE_FILTERED_PARAMS',
  FORM_DATA_SELECT_ITEM: DOCUMENT + 'FORM_DATA_SELECT_ITEM',
  ADD_NEW_REFERRAL: DOCUMENT + 'ADD_NEW_REFERRAL',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  changeSearch: data => ({
    type: actions.CHANGE_SEARCH,
    payload: data,
  }),

  changeFilteredParams: data => ({
    type: actions.CHANGE_FILTERED_PARAMS,
    payload: data,
  }),

  changeFormDateSelectItem: data => ({
    type: actions.FORM_DATA_SELECT_ITEM,
    payload: data,
  }),

  toggleModal: () => ({
    type: actions.TOGGLE_MODAL,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadFormData: data => ({
    type: actions.LOAD_FORM_DATA,
    payload: data,
  }),

  loadFormDataSuccess: data => ({
    type: actions.LOAD_FORM_DATA_SUCCESS,
    payload: data,
  }),

  addNewReferral: data => ({
    type: actions.ADD_NEW_REFERRAL,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
